// extracted by mini-css-extract-plugin
export var card = "styles-module--card--33G_r";
export var img = "styles-module--img--3dby6";
export var title = "styles-module--title--PlT__";
export var imgWrap = "styles-module--imgWrap--1TpbW";
export var textInner = "styles-module--textInner--1ebYp";
export var description = "styles-module--description--1PqvM";